<template>
  <!--导航栏-->
  <div id="userNav">
    
    
    <el-card :body-style="{ padding: '0px' }">
      
      <div style="padding: 25px 14px;background: orangered;color: white;font-size: 18px;font-weight: bold;">
        <span>{{name}}</span>
      </div>
      <el-menu
        :default-active="$route.name">
        <el-menu-item-group>
          <router-link to="/user/pre_waybill/create">
            <el-menu-item index="user_pre_waybill_create">
          <span slot="title">
            单件包裹录入
          </span>
            </el-menu-item>
          </router-link>
          <router-link to="/user/pre_waybill/batchImport">
            <el-menu-item index="user_pre_waybill_batchImport">
          <span slot="title">
            批量包裹导入
          </span>
            </el-menu-item>
          </router-link>
        </el-menu-item-group>

        <el-menu-item-group>
          <router-link to="/user/pre_waybill/list">
            <el-menu-item index="user_pre_waybill_list">
          <span slot="title">
           待发货管理
            </span>
            </el-menu-item>
          </router-link>
          <router-link to="/user/waybill/list">
            <el-menu-item index="user_waybill_list">
          <span slot="title">
            已发货管理
          </span>
            </el-menu-item>
          </router-link>
        </el-menu-item-group>
        <el-menu-item-group>
          <router-link to="/user/receiver/index">
            <el-menu-item index="user_receiver_index">
              <span slot="title">收件人库</span>
            </el-menu-item>
          </router-link>
          <router-link to="/user/sender/index">
            <el-menu-item index="user_sender_index">
              <span slot="title">发件人库</span>
            </el-menu-item>
          </router-link>

        </el-menu-item-group>
        <el-menu-item-group>
          <router-link to="/user/reset">
            <el-menu-item index="user_reset">
              <span slot="title">更改密码</span>
            </el-menu-item>
          </router-link>
            <el-menu-item index="logout" @click="logout">
              <span slot="title">退出系统</span>
            </el-menu-item>
        </el-menu-item-group>
      
      </el-menu>
    </el-card>
  </div>
  <!--导航结束-->
</template>
<script>
  import {mapGetters} from 'vuex';

  export default {
    computed: {
      ...mapGetters([
        'name',
        'avatar',
        'userToken'
      ])
    },
    methods: {
      logout() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
      },
    }
  };
</script>
<style rel="stylesheet/scss" lang="scss">
  
  
  #userNav {
    text-align: center;
    .el-menu-item-group {
      border-bottom: 2px solid #ddd;
      
    }
    .el-card {
      padding: 20px;
      img {
        width: 100px;
        border-radius: 50%;
      }
      .el-menu {
        border: none;
      }
    }
    a,
    a.link,
    a.hover,
    a.focus,
    a.visited {
      color: #303133;
    }
  }

</style>


// WEBPACK FOOTER //
// src/views/layout/UserNav.vue